export default "__VITE_ASSET__DvATKHhz__"